import React, { useEffect, useRef } from 'react'
import ReactResizeDetector, { withResizeDetector } from 'react-resize-detector'
import styled from 'styled-components'
import classNames from 'classnames'
import { categories } from '../data/cardInfo'

const SquareWrapper = styled.div`
  position: relative;
  width:100%;
  &:after {
    content: '';
    display:block;
    padding-bottom:100%;
  }
`

const CardWrapper = styled.div`
  position: absolute;
  width:100%;
  height:100%;
  color: white;
  font-size: ${props => props.width * 0.04}px;
  transition: transform 0.5s;
  transform-style: preserve-3d;
  &.rotated {
    transition: transform 0.5s;
    transform: rotateY(180deg);
  }
`

const CardFront = styled.div`
  position: absolute;
  width:100%;
  height:100%;
  backface-visibility:hidden;
  *{
    backface-visibility:hidden;
  }
  `

const CardBack = styled(CardFront)`
  position:absolute;
  top:0;
  left:0;
  width: 100%;
  height: 100%;
  transform: rotateY(180deg);
  `

const ImageWrapper = styled(CardWrapper)`
  position: relative;
`
const ImageFront = styled(CardFront)`
  position: relative;
`

const Header = styled.div`
  background: ${props => props.color};
  width:100%;
  text-transform: lowercase;
  height:50%;
  box-sizing:border-box;
  position: relative;
  text-align: left;

  h4 {
    font-weight: normal;
    position: absolute;
    bottom: 0.5em;
    left: 1em;
    max-width:70%;
    
    font-size:2em;
    margin:0;
  }
`
const Description = styled.div`
  background: ${props => props.color};
  text-align: left;
  height:50%;
  font-size: 0.9em;
  padding:1em 2em 1em 2em;
  box-sizing:border-box;
`

const Card = React.forwardRef(({cardData, example, forcedCategory}, ref) => {

  const catId = forcedCategory !== null ? forcedCategory : cardData.categoryId
  const category = categories.find(cat => cat.id === catId)
  const backImage = require(`../img/${example ? cardData.exampleBack : cardData.imgBack}`).default

  const rotated = false

  const handleResize = (w, h) => {
    
  }

  return (
  <div ref={ref} className='card-main'>
    {example ? (
      <ImageWrapper className={classNames({rotated})}>

      <ImageFront>
        <img src={require(`../img/${cardData.exampleFront}`).default} alt=""/>
      </ImageFront>

      </ImageWrapper>
    ) : (
      <SquareWrapper>
        <ReactResizeDetector handleWidth onResize={handleResize}>
        {({width, height}) => (
          <CardWrapper width={width} className={classNames({rotated})}>
            <CardFront>
              <Header color={category.topColor}><h4>{cardData.title}</h4></Header>
              <Description color={category.bottomColor}>{cardData.cardText}</Description>
            </CardFront>

          </CardWrapper>
        )}
        </ReactResizeDetector>
      </SquareWrapper>
    )}
  </div>
  )
})

export default Card
